import React from 'react';
import {InfoLingua} from './InfoLingua';
import { Box } from '@mui/material';
import { isEmpty } from 'lodash';
import { FaBookOpen, FaWaveSquare } from 'react-icons/fa';

const FormInfo = ({ inputText, 
    langLearn, 
    langBase, 
    explanationCallBack, 
    sentence, 
    sentenceCallBack , 
    selectedGender, 
    handleGenderChoiceChange,
    errorCallBack
}) => {
    const infoCallBack = (explanation, explanationType, explanationStyle, sentence) => {
        const explanationObj = typeof explanation === 'object'
            ? {
                explanation: explanation.explanation,
                explanationType: explanation.explanationType ?? explanationType,
                explanationStyle: explanation.explanationStyle ?? explanationStyle,
                model: explanation.model,
                service_name: explanation.service_name,
            }
            : { explanation, explanationType, explanationStyle };

        if (!isEmpty(sentence)) {
            if (sentence.addExplanation(explanationObj)) {
                sentence.saveSentence();
                const newSentence = sentence.deepCopy();
                newSentence.play = false;
                sentenceCallBack(newSentence);
            }
        } else {
            explanationCallBack(explanationObj);
        }
    };

    return (

 <Box sx={{ display: 'flex',  alignItems: 'center', justifyContent: 'space-between', width: '100%',
            paddingY:0, m:0, position:'relative', top:0 }}>            
            <InfoLingua
                // style={{ position: 'absolute', top: '0', left: 0 }}
                inputText={inputText}
                langLearn={langLearn}
                langBase={langBase}
                expl_type="grammar"
                expl_style="full"
                label="grammar"
                labelAlignment="right"
                icon={<FaBookOpen />}
                infoCallBack={infoCallBack}
                sentence={sentence}
                textOnly = {true}
                errorCallBack={(err) => errorCallBack(err)}
            />

            <InfoLingua
                // style={{ position: 'absolute', top: 0, right: 0 }}
                inputText={inputText}
                langLearn={langLearn}
                langBase={langBase}
                expl_type="pronunciation"
                label="phonetics"
                labelAlignment="left"
                expl_style="brief"
                icon={<FaWaveSquare />}
                infoCallBack={infoCallBack}
                sentence={sentence}
                textOnly = {true}
                errorCallBack={(err) => errorCallBack(err)}
            />
        </Box>
    );
};

export default FormInfo;
